import { useNavigate, useLocation } from 'react-router-dom';
import { Settings, ChartBar } from 'lucide-react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';

export function SubStepsNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const subSteps = [
    {
      id: '2.1',
      title: t('optimizationAnalysis.theoretical.subStepsNavigation.configuration'),
      description: t('optimizationAnalysis.theoretical.subStepsNavigation.configurationDescription'),
      icon: Settings,
      path: '/optimization/configure',
      active: location.pathname.includes('configure') || location.pathname === '/optimization'
    },
    {
      id: '2.2',
      title: t('optimizationAnalysis.theoretical.subStepsNavigation.analysis'),
      description: t('optimizationAnalysis.theoretical.subStepsNavigation.analysisDescription'),
      icon: ChartBar,
      path: '/optimization/analysis',
      active: location.pathname.includes('analysis')
    }
  ];

  return (
    <div className="flex justify-center mb-8">
      <div className="flex items-center gap-3">
        {subSteps.map((step, index) => (
          <div key={step.id} className="flex items-center">
            <button
              onClick={() => navigate(step.path)}
              className={clsx(
                'flex items-center gap-2 px-4 py-2.5 rounded-xl transition-all duration-200',
                step.active
                  ? 'bg-brand-primary text-white shadow-sm'
                  : 'bg-white border border-gray-200 text-gray-600 hover:border-gray-300 hover:shadow-sm'
              )}
            >
              <step.icon className="w-4 h-4" />
              <span className="font-medium text-sm">{step.id} {step.title}</span>
            </button>
            {index < subSteps.length - 1 && (
              <div className="w-12 h-0.5 bg-gray-400 mx-3" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}